import React from 'react';
import './index.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Text, { SIZES as textSizes, TYPES as textTypes } from 'components/elements/Text';
import Icon from 'components/elements/iconsSize';

export const LabelPositions = {
   left: 'left',
   right: 'right',
};

const CheckBox = ({
   name, checked, onChange, label, disabled, labelPosition, iconType, textProps,
}) => {
   const isChecked = !!checked;

   return (
      <div
         onClick={disabled ? () => { } : () => onChange(name, !isChecked)}
         role='presentation'
         className={
            classNames(
               'checkBox',
               {
                  'checkBox__disabled': disabled,
                  'checkBox__isChecked__disabled': isChecked && disabled,
                  'checkBox__isChecked': isChecked && !disabled,
                  'checkBox__isNotChecked': !isChecked && !disabled,
                  'checkBox__left': !!label && labelPosition === 'left',
               })
         }
      >
         <div className='checkBox__square'>
            {isChecked && (iconType === 'icon' ? <Icon name='Checkbox' /> : (<div className='checkBox__square__icon' />))}
         </div>
         {!!label && (
            <div className='checkBox__label'>
               <Text
                  size={textSizes.medium}
                  type={textTypes.regular}
                  inner={label}
                  {...textProps}
               />
            </div>
         )}
      </div>
   );
};

export default CheckBox;

CheckBox.propTypes = {
   name: PropTypes.string,
   checked: PropTypes.any,
   onChange: PropTypes.func,
   label: PropTypes.any,
   iconType: PropTypes.string,
   disabled: PropTypes.bool,
   textProps: PropTypes.object,
   labelPosition: PropTypes.string,
};

CheckBox.defaultProps = {
   checked: false,
   label: '',
   onChange: () => { },
   labelPosition: 'right',
   iconType: 'icon',
};
